module.exports = __webpack_public_path__ + "static/img/8.d8543f3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/8.png
// module id = OAHJ
// module chunks = 0